<template>
  <div>
    <!-- Account Locked Full Screen Overlay -->
    <AccountLocked 
      v-if="showAccountLocked" 
      @back-to-login="handleBackToLogin"
    />

    <div v-if="showSendSuccess" class="send-success-toast" role="status">
      <img src="@/assets/mdi_success-bold.svg" alt="Success" width="22" height="22" style="margin-right: 12px; vertical-align: middle;" />
      <span class="toast-message">{{ sendMessage }}</span>
    </div>

    <!-- Login Form -->
    <img src="@/assets/bgLocked.png" cover class="full-height-image" alt="lock">
    <v-container v-show="!showAccountLocked" fluid class="pa-0 ma-0" >
      <img v-if="!forgotpassword" src="@/assets/Bg element.png" cover class="full-height-image" alt="lock1"/>
      <v-row style="height: 100vh; width: 100%; margin: 0; display: flex; justify-content: center; align-items: center;">
        <v-col
          cols="12"
          sm="6"
          md="6"
          lg="6"
          v-if="!isMobile && !forgotpassword"
          style="display: flex; justify-content: center; align-items: center;"
          class="bg-image-container"
        >
        </v-col>
      <v-col
        cols="12"
        sm="6"
        md="6"
        lg="6"
        class="login-scroll-container"
        style="padding: 0; height: 100vh; overflow-y: auto"
      >
        <div
          v-if="!hasCredential && switchToLogin"
          class="login-form-container"
        >
          <v-row
            align="center"
            justify="center"
            class="img-intersection2"
            style="margin-left: 20px; height: auto"
          >
            <v-col cols="12" sm="8" md="8">
               <div class="mt-12 mb-12" v-if="!forgotpassword" style="justify-content: center; align-items: center; display: flex;">
                <div class="logo-container">
                  <img 
                    alt="Fusion Logo"
                    :src="images.logo"
                    style="width: 320px;"
                  />
                  <div
                    class="label-version mr-2">
                    {{ versioning != null && versioning != "" ? "Version" : "" }}
                    {{ "R" + versioning }}
                  </div>
                </div>
               </div>

              <div v-if="!forgotpassword">
                <div v-if="triedLogin && passwordErrorMsg" class="required-message" style="color: red; margin-top: 16px; text-align: center; font-weight: 600; font-size: 12px;">
                  {{ passwordErrorMsg }}
                </div>
              </div>

              <div class="forgot-container">
                <div v-if="forgotpassword">
                  <div class="img-chat">
                    <div class="logo-container">
                    <img alt="Fusion Logo" :src="images.logo" style="width:300px;" />
                    <div
                      class="label-version mr-2">
                      {{ versioning != null && versioning != "" ? "Version" : "" }}
                      {{ "R" + versioning }}
                    </div>
                    </div>
                  </div>
                  <div style="margin-left: 100px;">
                  <v-form class="form ml-3 mr-3">
                    <h3 class="mt-6" style="color: #001763; font-weight: 500;">Having trouble logging in?</h3>
                    <p style="color: gray;">Please enter your email address or username, and a new password will be sent to you.</p>

                    <div v-if="ProductAdminFlag" class="forgot-input">
                      <v-text-field
                        v-model="input.companyCode"
                        variant="plain"
                        id="companycode-login"
                        type="text"
                        hide-details="true"
                        @keyup.enter="login"
                        @input="companyCodeChecker = false"
                        @focus="companyCodeFocused = true"
                        @blur="companyCodeFocused = false"
                        :error="companyCodeChecker"
                        :maxlength="10"
                        :class="['animated-input', (input.companyCode || companyCodeFocused) ? 'username-filled' : '']"
                        :style="{
                          marginTop: '10px',
                          borderRadius: '10px',
                            borderColor: (forgotMode && companyCodeChecker && !input.companyCode) ? '#E38C0B' : (forgotMode && companyCodeChecker && input.companyCode) ? 'red' : '',
                            borderWidth: (forgotMode && companyCodeChecker) ? '1px' : '',
                            borderStyle: (forgotMode && companyCodeChecker) ? 'solid' : '',
                        }"
                      > <!-- username-filled is css class -->
                  
                        <!-- Floating placeholder -->
                        <template #prepend-inner>
                          <span
                            class="floating-placeholder"
                            :class="{ 'move-right': input.companyCode }"
                          >
                            Company Code<span style="color: red; margin-left: 6px;">*</span>
                          </span>
                        </template>

                        <!-- Icon on the right -->
                        <template #append-inner>
                          <v-img
                            :src="imagesIcon.CCIcon"
                            width="25"
                            height="25"
                            contain
                            class="field-icon"
                          ></v-img>
                        </template>
                      </v-text-field>

                      <!-- Required message -->
                      <div
                          v-if="forgotMode && companyCodeChecker && !input.companyCode"
                        class="required-message"
                        style="color: #E38C0B; margin-bottom: -24px; margin-top: 8px; font-size: small;"
                      >
                        Company Code is required !
                      </div>

                    </div>

                    <div class="forgot-input mt-8">
                      <v-text-field
                        v-model="input.username"
                        variant="plain"
                        id="email-username-forgot-password-login"
                        name="login"
                        type="text"
                        hide-details="true"
                        @keyup.enter="login"
                        @input="userNameChecker = false"
                        @focus="usernameFocused = true"
                        @blur="usernameFocused = false"
                        :error="userNameChecker"
                        :class="['animated-input', (input.username || usernameFocused) ? 'username-filled' : '']"
                          :style="{
                            marginTop: '16px',
                            borderRadius: '10px',
                            borderColor: (forgotMode && userNameChecker && !input.username) ? '#E38C0B' : (forgotMode && userNameChecker && input.username) ? 'red' : '',
                            borderWidth: (forgotMode && userNameChecker) ? '1px' : '',
                            borderStyle: (forgotMode && userNameChecker) ? 'solid' : '',
                          }"
                      >
                        <!-- Floating placeholder text -->
                        <template #prepend-inner>
                          <span
                            class="floating-placeholder"
                            :class="{ 'move-right': input.username }"
                          >
                            Email or Username<span style="color: red; margin-left: 6px;">*</span>
                          </span>
                        </template>

                        <!-- Right side icon -->
                        <template #append-inner>
                          <img
                            src="@/assets/email@userName.svg"
                            width="25"
                            height="25"
                            class="field-icon"
                            contain
                            alt="mail"
                          ></img>
                        </template>
                      </v-text-field>

                      <!-- Required message -->
                      <div
                        v-if="forgotMode && userNameChecker && !input.username"
                        class="required-message"
                        style="color: #E38C0B; margin-bottom: -26px; margin-top: 8px; font-size: small;"
                      >
                        Username or Email is required !
                      </div>
                    </div>
                  </v-form>
                  <v-layout class="forgot-buttons">
                    <v-btn
                      v-show="forgotpassword"
                      id="back-to-login-button"
                      class="forgot-login mt-4"
                      align="center"
                      justify="center"
                      v-on:click="forgotpassword = !forgotpassword; forgotMode = false; companyCodeChecker=false; userNameChecker=false;"
                      >
                        <span>Back To Login</span>
                    </v-btn>
                    <v-btn
                      v-show="forgotpassword"
                      id="send-forgot-password-login"
                      class="forgot-send mt-4"
                      align="center"
                      justify="center"
                      @click="forgot"
                      :loading="loading"
                    >
                      <span>Send</span>
                    </v-btn>
                  </v-layout>
                  </div>
                </div>
              </div>

              <div v-if="!forgotpassword">
                <v-form class="form">
                  <div v-if="ProductAdminFlag" class="form-group">
                    <v-text-field
                      v-model="input.companyCode"
                      variant="plain"
                      id="company-code-login"
                      name="company-code"
                      type="text"
                      hide-details="true"
                      @keyup.enter="login"
                      @input="companyCodeChecker = false"
                      @focus="companyCodeFocused = true"
                      @blur="companyCodeFocused = false"
                      :error="companyCodeChecker"
                      :class="['animated-input', (input.companyCode || companyCodeFocused) ? 'username-filled' : '']"
                      :style="{
                        marginTop: '33px',
                        marginBottom: '0px',
                        borderRadius: '10px',
                        borderColor: (triedLogin && companyCodeChecker && !input.companyCode) ? '#E38C0B' : (triedLogin && companyCodeChecker && input.companyCode) ? 'red' : '',
                        borderWidth: (triedLogin && companyCodeChecker) ? '1px' : '',
                        borderStyle: (triedLogin && companyCodeChecker) ? 'solid' : '',
                      }"
                    >
                      <!-- Floating placeholder text -->
                      <template #prepend-inner>
                        <span
                          class="floating-placeholder"
                          :class="{ 'move-right': input.companyCode }"
                        >
                          Company Code<span style="color: red; margin-left: 6px;">*</span>
                        </span>
                      </template>

                      <!-- Right side icon -->
                      <template #append-inner>
                        <v-img
                          :src="imagesIcon.CCIcon"
                          width="25"
                          height="25"
                          contain
                          class="field-icon"
                        ></v-img>
                      </template>
                    </v-text-field>

                    <!-- Required message -->
                    <div
                      v-if="triedLogin && companyCodeChecker && !input.companyCode"
                      class="required-message"
                      style="color: #E38C0B; margin-bottom: -26px; margin-top: 8px; font-size: small;"
                    >
                      Company Code is required !
                    </div>
                  </div>
                  <!-- <div v-if="ProductAdminFlag" class="d-flex align-center">
                    <v-divider horizontal class="mx-2"></v-divider>
                    <span
                      style="
                        color: grey;
                        font-size: smaller;
                        width: -webkit-fill-available;
                        text-align: center;
                      "
                    >
                      Login with username
                    </span>
                    <v-divider horizontal class="mx-2"></v-divider>
                  </div> -->
                  <div class="form-group">
                    <v-text-field
                      v-model="input.username"
                      variant="plain"
                      id="username-login"
                      name="username"
                      type="text"
                      hide-details="true"
                      @keyup.enter="login"
                      @input="userNameChecker = false"
                      @focus="usernameFocused = true"
                      @blur="usernameFocused = false"
                      :error="userNameChecker"
                      :class="['animated-input', (input.username || usernameFocused) ? 'username-filled' : '']"
                      :style="{
                        marginTop: '33px',
                        marginBottom: '0px',
                        borderRadius: '10px',
                        borderColor: (triedLogin && userNameChecker && !input.username) ? '#E38C0B' : (triedLogin && userNameChecker && input.username) ? 'red' : '',
                        borderWidth: (triedLogin && userNameChecker) ? '1px' : '',
                        borderStyle: (triedLogin && userNameChecker) ? 'solid' : '',
                      }"
                    >
                      <!-- Floating placeholder text -->
                      <template #prepend-inner>
                        <span
                          class="floating-placeholder"
                          :class="{ 'move-right': input.username }"
                        >
                          Username<span style="color: red; margin-left: 6px;">*</span>
                        </span>
                      </template>

                      <!-- Right side icon -->
                      <template #append-inner>
                        <v-img
                          :src="imagesIcon.BGIcon"
                          width="25"
                          height="25"
                          contain
                          class="field-icon"
                        ></v-img>
                      </template>
                    </v-text-field>

                    <!-- Required message -->
                    <div
                      v-if="triedLogin && userNameChecker && !input.username"
                      class="required-message"
                      style="color: #E38C0B; margin-bottom: -26px; margin-top: 8px; font-size: small;"
                    >
                      Username is required !
                    </div>
                  </div>

                  <div class="form-group">
                    <v-text-field
                      v-model="input.password"
                      id="password-login"
                      name="password"
                      variant="plain"
                      :type="show1 ? 'text' : 'password'"
                      hide-details="true"
                      @keyup.enter="login"
                      @input="passwordChecker = false; passwordErrorMsg = ''"
                      @focus="passwordFocused = true"
                      @blur="passwordFocused = false"
                      :error="passwordChecker"
                      :class="['animated-input', (input.password || passwordFocused) ? 'username-filled' : '']"
                      :style="{
                        marginTop: '33px',
                        marginBottom: '0px',
                        borderRadius: '10px',
                        borderColor: (triedLogin && passwordChecker && !input.password) ? '#E38C0B' : (triedLogin && passwordChecker && input.password) ? 'red' : '',
                        borderWidth: (triedLogin && passwordChecker) ? '1px' : '',
                        borderStyle: (triedLogin && passwordChecker) ? 'solid' : '',
                      }"
                    >
                      <!-- Floating placeholder text -->
                      <template #prepend-inner>
                        <span
                          class="floating-placeholder"
                          :class="{ 'move-right': input.password }"
                        >
                          Password<span style="color: red; margin-left: 6px;">*</span>
                        </span>
                      </template>

                      <!-- Right-side password toggle icon -->
                      <template #append-inner>
                        <v-img
                          @click="show1 = !show1"
                          :src="show1 ? imagesIcon.PwOnIcon : imagesIcon.PwOffIcon"
                          width="25"
                          height="25"
                          alt="img"
                          class="field-icon"
                          contain
                        ></v-img>
                      </template>
                    </v-text-field>

                    <!-- Required message -->
                    <div
                      v-if="triedLogin && passwordChecker && !input.password"
                      class="required-message"
                      style="color: #E38C0B; margin-bottom: -22px; margin-top: 8px; font-size: small;"
                    >
                      Password is required !
                    </div>
                  </div>
                </v-form>
              </div>

              <div v-if="!forgotpassword" class="d-flex align-center justify-space-between mt-4" style="height: 42px; color: #646464;">
                <v-checkbox
                  :label="$t('rememberme')"
                  v-model="rememberMe"
                  id="remember-me-login"
                  hide-details
                  density="compact"
                ></v-checkbox>

                <a
                  v-show="!forgotpassword"
                  @click="forgotpassword = !forgotpassword"
                  class="forgotPassword"
                  id="forgot-password-login"
                >
                  {{ $t("forgotpassword") }}
                </a>
              </div>


              <v-btn
                    v-show="!forgotpassword"
                    id="login-button"
                    class="login"
                    @click="login"
                    :loading="loading"
                    style="font-weight: 600;"
              >
                <span style="font-weight: 600;">{{ $t("login") }}</span>
              </v-btn>

              <!-- <div v-if="SSOMicrosoftFlag == true" class="d-flex align-center">
                <v-divider horizontal class="mx-2"></v-divider>
                <span
                  style="
                    color: grey;
                    font-size: smaller;
                    width: -webkit-fill-available;
                    text-align: center;
                  "
                  >Sign in with</span
                >
                <v-divider horizontal class="mx-2"></v-divider>
              </div> -->

              <div v-if="!forgotpassword" class="hr-or">
                <hr style="flex: 1; border: 1px solid #A6A6A6;" />
                <span style="margin: 0 44px; color: #171717;">Or</span>
                <hr style="flex: 1; border: 1px solid #A6A6A6;" />
              </div>

              <div v-if="!forgotpassword" class="d-flex justify-space-between" id="sign-in">
                <div
                  class="sign-in-microsoft"
                  v-if="SSOMicrosoftFlag"
                  style="width: calc(65% + 40px); justify-content: space-around;"
                >
                  <v-btn
                    @click="loginMicrosoft"
                    class="btn-sign-in"
                    id="login-microsoft-button"
                  >
                    <div class="d-flex align-center">
                      <img width="30" height="22" src="@/assets/logos_microsoft-icon.svg" />&nbsp;&nbsp;&nbsp;
                      <span style="font-size: 12px; font-weight: 500;">{{ $t("loginMicrosoft") }}</span>
                    </div>
                  </v-btn>
                </div>

                <div
                  class="sign-in-authentik"
                  v-if="SSOAuthentikFlag"
                  style="width: calc(65% + 40px); justify-content: space-around;"
                >
                  <v-btn
                    @click="loginAuthentik"
                    class="btn-sign-in"
                    id="login-authentik-button"
                  >
                  <img width="30" src="@/assets/authentik_icon.svg" />&nbsp;
                  <span style="font-size: 12px; font-weight: 500;">{{ $t("loginAuthentik") }}</span>
                  </v-btn>
                </div>
              </div>

              <!-- <v-layout v-show="SSOAuthentikFlag" flex align-center justify-center style="margin-top: 2rem">
                <v-btn class="loginMicrosoft " large align="center" justify="center" @click="loginLine">
                  <img width="30" src="@/assets/logo-line.svg" />&nbsp;
                  {{ $t('loginLine') }}
                </v-btn>
              </v-layout> -->
            </v-col>
          </v-row>
        </div>

        <div
          v-else
          style="
            display: flex;
            align-items: center;
            justify-content: center;
            height: 100vh;
          "
        >
          <v-card
            style="
              border: 0px;
              border-radius: 15px;
              height: 450px;
              width: 500px;
              box-shadow: 6px 8px 15px rgba(0, 0, 0, 0.15);
            "
          >
            <v-card-title class="d-flex align-center justify-center">
              <div class="login-container">
                <div class="user-image" style="margin: 0px 0 25px 0">
                  <img :src="images.user" alt="User Profile Image" />
                </div>
                <h2 style="margin-bottom: 5px">{{ fullname }}</h2>
                <p style="font-size: smaller; margin-bottom: 25px; color: grey">
                  {{ companyName }}
                </p>
                <v-alert
                  v-if="errorRememberAlert"
                  type="error"
                  height="50"
                  class="d-flex align-center justify-center"
                  >The User was not found.</v-alert
                >
                <v-btn
                  @click="login"
                  :loading="loading"
                  class="login"
                  style="height: 50px"
                  >{{ $t("login") }}</v-btn
                >
                <p class="changeAccount">
                  <span
                    style="text-decoration: underline; cursor: pointer"
                    @click="SwitchToLogin"
                  >
                    Change account</span
                  >
                </p>
              </div>
            </v-card-title>
          </v-card>
        </div>
      </v-col>
    </v-row>
    <v-overlay :value="dialog">
      <v-dialog v-model="dialog" persistent width="300">
        <v-card color="#1976D2" dark>
          <v-card-text class="white--text">
            Loading Please Wait...
            <v-progress-linear
              indeterminate
              color="#FAA91B"
              class="mb-0"
            ></v-progress-linear>
          </v-card-text>
        </v-card>
      </v-dialog>
    </v-overlay>
    </v-container>
  </div>
</template>
<script>
import LogTrace from "@/api/function.js";
import Cookies from "js-cookie";
import CryptoJS from "crypto-js";
import logoImg from "@/assets/Group 141.png";
import bgImg from "@/assets/images/login.figma.png";
import bgIcon from "@/assets/images/stash_user-id.png";
import companyCodeIcon from "@/assets/images/carbon_location-company.png";
import passwordOnIcon from "@/assets/images/lock-on.png"; 
import passwordOffIcon from "@/assets/images/lock-off.png";
import userImg from "@/assets/images/user.png";
import AccountLocked from "@/views/AccountLocked.vue";
import { useDisplay } from "vuetify";
import { version } from "../../package.json";
// import utils from '@/utils';

export default {
  mixins: [LogTrace],
  name: "Login",
  components: {
    AccountLocked,
  },
  inject: ["flagNav", "LoginLogo", "colorThemeChat"],
  setup() {
    const display = useDisplay();
    return { display };
  },
  data() {
    return {
      versioning: version,
      showSendSuccess: false,
      sendMessage: "",
      showAccountLocked: false,
      companyCodeChecker: false,
      userNameChecker: false,
      passwordChecker: false,
      expiryDate: "",
      switchToLogin: true,
      rememberMe: false,
      dialog: false,
      loading: false,
      forgotpassword: false,
      erroralert: false,
      errorRememberAlert: false,
      successalert: false,
      successMessage: "",
      errorMessage: "",
      show1: false,
      remember: "",
      companyName: "",
      fullname: "",
      secretKey: "SecretPassphrase@2020",
      permissionID: [],
      hasCredential: false,
      input: {
        companyCode: "",
        username: "",
        password: "",
      },
      usernameFocused: false,
      passwordFocused: false,
      companyCodeFocused: false,
      forgotMode: false,
      authenticated: Cookies.get("authenticated"),
      rememberMetext: Cookies.get("rememberMe"),
      Email: "",
      images: {
        logo: logoImg,
        BG: bgImg,
        user: userImg,
      },
      imagesIcon: {
        BGIcon: bgIcon,
        CCIcon: companyCodeIcon,
        PwOnIcon: passwordOnIcon,
        PwOffIcon: passwordOffIcon,
      },
      SSOMicrosoftFlag: false,
      SSOAuthentikFlag: false,
      ProductAdminFlag: false,
      triedLogin: false,
      passwordErrorMsg: '', // Add this line
    };
  },
  async created() {
    this.ProductAdminFlag = import.meta.env.VITE_APP_ProductAdmin === "true";
  },
  mounted: function () {
    if (this.LoginLogo != null && this.LoginLogo != undefined) {
      this.images.logo = this.LoginLogo;
    }
    if (this.authenticated) {
      if (Cookies.get("roleId") == 0 || Cookies.get("roleId") == 1) {
        this.$router.push(`/dashboard`);
      } else if (Cookies.get("roleId") == 2 || Cookies.get("roleId") == 6) {
        this.$router.push(`/GPTModelManagement`);
      }
    } else {
      Object.keys(Cookies.get()).forEach(function (cookieName) {
        if (cookieName != "rememberMe") {
          Cookies.remove(cookieName);
        }
      });
    }
    const rememberMeCookie = Cookies.get("rememberMe");
    if (rememberMeCookie) {
      let key = CryptoJS.enc.Hex.parse(import.meta.env.VITE_APP_JSKey);
      let decryptedData = this.decryptData(rememberMeCookie, key);
      const userData = JSON.parse(decryptedData);
      this.input.companyCode = userData.companyCode;
      this.input.username = userData.username;
      this.input.password = userData.password;
      this.companyName = userData.companyName;
      this.fullname = userData.fullname;
      this.hasCredential = true;
      this.switchToLogin = false;
      this.rememberMe = true;
      // const userData = JSON.parse(rememberMeCookie);
      // this.input.username = userData.username;
      // this.input.password = userData.password;
      // this.rememberMe = true;
    }
    this.CheckStatusSSO();
    // let login_username = this.readCookie("username");
    // let login_password = this.readCookie("password");
    // this.remember = this.readCookie("rememberme");
    // if (this.remember == "true") {
    //   this.expiryDate = this.readCookie("expiredate");
    //   let today = new Date();
    //   if (today >= this.expiryDate) {
    //     document.cookie = "username=" + ";expires=" + self.expiryDate;
    //     document.cookie = "password=" + ";expires=" + self.expiryDate;
    //     document.cookie = "rememberme=" + ";expires=" + self.expiryDate;
    //   } else {
    //     if (login_username != null && login_password != null) {
    //       this.input.username = this.cryptoMethods("decrypt", login_username);
    //       this.input.password = this.cryptoMethods("decrypt", login_password);
    //       this.login();
    //     }
    //   }
    // } else {
    //   this.expiryDate = new Date();
    //   this.expiryDate.setMonth(this.expiryDate.getMonth() + 1);
    //   document.cookie = "expiredate=" + this.expiryDate;
    // }
  },
  computed: {
    loginLogo() {
      return this.LoginLogo;
    },
    isMobile() {
      return !this.display.smAndUp.value;
    },
  },
  watch: {
    loginLogo(newValue) {
      this.images.logo = `${newValue}`;
    },
  },
  methods: {
    SwitchToLogin() {
      this.input.companyCode = "";
      this.input.username = "";
      this.input.password = "";
      this.hasCredential = false;
      this.switchToLogin = true;
      this.forgotMode = false;
    },
    async CheckStatusSSO() {
      let self = this;
      var tempRequest = {
        key: "SSO",
      };
      self.$call.CheckStatusSSO(
        tempRequest,
        async (dataResponse) => {
          if (dataResponse.status == 0) {
            console.log("SSO Status:", dataResponse.data.microsoft);
            self.SSOAuthentikFlag = dataResponse.data.authentik;
            self.SSOMicrosoftFlag = dataResponse.data.microsoft;
            // self.ProductAdminFlag = await utils.decryptCipherText(dataResponse.data.productAdminFlag, import.meta.env.VITE_APP_EncryptLogKey, import.meta.env.VITE_APP_EncryptLogIV);
          }
        },
        (errorResource) => {
          console.error(errorResource);
        }
      );
    },

    async loginMicrosoft() {
      if (this.ProductAdminFlag && this.companyCodeInputCheck()) return;
      let self = this;
      self.clearMessage();
      Cookies.remove("userId");
      Cookies.remove("rememberMe");

      window.open(
        `${import.meta.env.VITE_APP_API}api/v0/SSO/SignIn?companyCode=${
          this.input.companyCode
        }`,
        "Popup",
        "width=850,height=750"
      );

      window.addEventListener("message", async function (event) {
        try {
          const data = event.data;
          let blocker = false;
          if (blocker) {
            console.log("Session Storage:", data);
            console.log("Cookies:", data.cookies);
          }

          window.location.reload(true);
        } catch (error) {
          return;
        }
      });
    },

    async loginAuthentik() {
      if (this.ProductAdminFlag && this.companyCodeInputCheck()) return;
      let self = this;
      self.clearMessage();

      Cookies.remove("userId");
      Cookies.remove("rememberMe");

      window.open(
        `${
          import.meta.env.VITE_APP_API
        }api/v0/SSO/SignInAuthentik?companyCode=${this.input.companyCode}`,
        "Popup",
        "width=850,height=750"
      );

      window.addEventListener("message", async function (event) {
        try {
          const data = event.data;
          let blocker = false;
          if (blocker) {
            console.log("Session Storage:", data);
            console.log("Cookies:", data.cookies);
          }

          window.location.reload(true);
        } catch (error) {
          return;
        }
      });
    },

    login: function () {
      this.triedLogin = true;
      let self = this;

      // Front-end required field validation BEFORE API call
      let hasError = false;
      // Company code only required when ProductAdminFlag true
      if (self.ProductAdminFlag && !self.input.companyCode) {
        self.companyCodeChecker = true;
        hasError = true;
      } else {
        self.companyCodeChecker = false;
      }
      if (!self.input.username) {
        self.userNameChecker = true;
        hasError = true;
      } else {
        self.userNameChecker = false;
      }
      if (!self.input.password) {
        self.passwordChecker = true;
        hasError = true;
      } else {
        self.passwordChecker = false;
      }
      // Abort if any required missing so required message condition triggers
      if (hasError) return;

      self.clearMessage();
      self.loading = true;
      const companyCode = self.input.companyCode?.trim().toLowerCase();
      const userName = self.input.username?.trim().toLowerCase();
      const password = self.input.password;

      self.$call.Login(
        {
          CompanyCode: companyCode,
          UserName: userName,
          Password: password,
        },
        (dataResponse) => {
          self.loading = false;
          if (dataResponse.status == 0) {
            if (self.rememberMe) {
              let key = CryptoJS.enc.Hex.parse(import.meta.env.VITE_APP_JSKey);
              let data = JSON.stringify({
                companyName: dataResponse.data.companyName,
                fullname: dataResponse.data.fullName,
                companyCode: companyCode,
                username: userName,
                password: password,
              });
              let encryptedData = self.encryptData(data, key);
              Cookies.set("rememberMe", encryptedData, { expires: 365 });
              window.location.reload(true);
            } else {
              Cookies.remove("rememberMe");
              window.location.reload(true);
            }
          } else {
            // Handle backend validation errors for companyCode, userName, password
            if (dataResponse.errors) {
              if (dataResponse.errors.companyCode) {
                self.companyCodeChecker = true;
                self.companyCodeErrorMsg = dataResponse.companyCode;
              }
              if (dataResponse.errors.userName) {
                self.userNameChecker = true;
                self.userNameErrorMsg = dataResponse.userName;
              }
              if (dataResponse.errors.password) {
                self.passwordChecker = true;
                self.passwordErrorMsg = dataResponse.password;
              }
            } else if (dataResponse.message) {
              // Check if account is locked
              if (
                dataResponse.message ===
                  "Invalid login credentials. Please try again. (3/3)" ||
                dataResponse.message === "Account is locked!"
              ) {
                self.showAccountLocked = true;
                return;
              } else {
                // Generic invalid credentials or other auth error
                // Mark all provided fields with red border (value present but invalid)
                if (self.ProductAdminFlag) {
                  self.companyCodeChecker = true; // will render red if companyCode has value
                }
                self.userNameChecker = true;
                self.passwordChecker = true;
                self.passwordErrorMsg = dataResponse.message;
              }
            }
          }
        },
        (errorResource) => {
          self.loading = false;
          self.passwordChecker = true;
          self.passwordErrorMsg =
            errorResource || "Login failed. Please try again.";
        }
      );
    },
    handleBackToLogin() {
      this.showAccountLocked = false;
      this.input.companyCode = "";
      this.input.username = "";
      this.input.password = "";
      this.passwordChecker = false;
      this.passwordErrorMsg = "";
      this.triedLogin = false;
    },
    companyCodeInputCheck() {
      if (!this.input.companyCode) {
        this.companyCodeChecker = true;
        return true;
      }
      this.companyCodeChecker = false;
      return false;
    },

    // async loginLine() {
    //   let self = this;
    //   self.clearMessage();

    //       var myWindow = window.open(`${import.meta.env.VITE_APP_API}api/v0/SSO/SignInLine`, "Popup", "width=850,height=750");

    //   Cookies.remove('userId');
    //   var stopLoop = false;

    //   do {
    //     console.log('Wait for 5 seconds!');
    //     // if(Cookies.get('userId') != undefined)
    //     if(myWindow.closed == true)
    //     {
    //       stopLoop = true;
    //       window.location.reload(true);
    //     }
    //     await new Promise((resolve) => setTimeout(resolve, 5000));
    //   } while (stopLoop == false);
    // },

    forgot() {
      try {
        let self = this;
        // validation for forgot password form
        self.forgotMode = true; // flag to differentiate styling
        let hasError = false;
        if (self.ProductAdminFlag && !self.input.companyCode) {
          self.companyCodeChecker = true;
          hasError = true;
        }
        if (!self.input.username) {
          self.userNameChecker = true;
          hasError = true;
        }
        if (hasError) {
          return; // abort API call
        }
        self.dialog = true;
        self.loading = true;
        self.$call.ForgetPassword(
          self.input.username,
          (dataResponse) => {
            if (dataResponse.status == 0) {
              // self.$swal.fire({
              //   icon: "success",
              //   title: dataResponse.message,
              //   showConfirmButton: false,
              //   timer: 1500,
              // });
              this.showSendSuccess = true;
              this.sendMessage = dataResponse.message,
              clearTimeout(this._deleteToastTimer);
                this._deleteToastTimer = setTimeout(() => {
                  this.showSendSuccess = false;
                }, 1500);
              self.loading = false;
              self.dialog = false;
              self.forgotpassword = false;
              self.forgotMode = false;
            } else {
              // Backend indicates failure - show red borders on supplied values
              self.loading = false;
              self.dialog = false;
              if (self.ProductAdminFlag) self.companyCodeChecker = true;
              self.userNameChecker = true;
            }
          },
          (errorResource) => {
            self.erroralert = true;
            self.errorMessage = errorResource;
            self.loading = false;
            self.dialog = false;
            // Also mark as invalid so user sees red borders
            if (self.ProductAdminFlag) self.companyCodeChecker = true;
            self.userNameChecker = true;
          }
        );
      } catch (error) {
        this.LogTrace(error, "forgotPassword");
      }
    },
    clearMessage: function () {
      this.erroralert = false;
      this.successalert = false;
      this.errorMessage = "";
      this.successMessage = "";
    },
    readCookie(name) {
      let nameEQ = name + "=";
      let ca = document.cookie.split(";");
      for (let i = 0; i < ca.length; i++) {
        let c = ca[i];
        if (type == "encrypt") {
          const encryptedText = this.CryptoJS.AES.encrypt(
            value,
            self.secretKey
          ).toString();
          return encryptedText;
        } else {
          const decryptedText = this.CryptoJS.AES.decrypt(
            value,
            self.secretKey
          ).toString(this.CryptoJS.enc.Utf8);
          return decryptedText;
        }
      }
    },
    encryptData(data, key) {
      let encryptedData = CryptoJS.AES.encrypt(JSON.stringify(data), key, {
        keySize: 256 / 32,
        iv: key,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      return encryptedData.toString();
    },
    decryptData(data, key) {
      let decryptedData = CryptoJS.AES.decrypt(data, key, {
        keySize: 256 / 32,
        iv: key,
        mode: CryptoJS.mode.CBC,
        padding: CryptoJS.pad.Pkcs7,
      });
      return JSON.parse(decryptedData.toString(CryptoJS.enc.Utf8));
    },
  },
};
</script>
<style scoped>

.forgot {
  width: 10rem;
}

.login {
  width: 100%;
  border-radius: 10px;
  background: linear-gradient(90deg, #C32E0E, #F67760) !important;
  color: #ffffff;
  padding: 10px;
  gap: 10px;
  height: 40px;
  margin-top: 24px;
}

.forgot-login {
  width: 200px;
  height: 43px;
  border-radius: 6px;
  border: 1px solid #949AA8;
  background: #ffffff;
}
.forgot-login span {
  color: #171717;
  font-weight: 600;
  font-size: 13px;
}

.forgot-send {
  width: 200px;
  height: 43px;
  border-radius: 6px;
  background: linear-gradient(90deg, #c32e0b, #f67760) !important;
}

.forgot-send span {
  color: #ffffff;
  font-weight: 600;
  font-size: 13px;
}

.hr-or{
  display: flex;
  align-items: center;
  text-align: center;
  width: 100%;
  margin-top: 2rem;
  margin-bottom: 2rem;
}

.form {
  min-width: 50%;
}

.img-intersection {
  width: 100%;
  height: 100%;
  max-width: 100%;
}

.login-scroll-container {
  overflow-y: auto;
  -webkit-overflow-scrolling: touch; /* สำหรับ iOS */
}

.login-form-container {
  position: relative;
  min-height: 100%;
}

/* แก้ไข img-intersection2 ไม่ให้มีความสูงตายตัวเกินไป */
.img-intersection2 {
  width: 100%;
  height: auto;
  min-height: 80vh;
  max-width: 100%;
}

@media (min-width: 960px) {
    .v-col-md-8 {
        flex: 0 0 80%;
        max-width: 80%;
    }
}

@media (min-width: 600px) {
    .v-col-sm-8 {
        flex: 0 0 80%;
        max-width: 80%;
    }
}

#sign-in {
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  gap: 28px;
  margin-top: 1rem;
}

.sign-in-microsoft, .sign-in-authentik {
  width: 65%;
  justify-content: space-around;
  display: flex;
}

.btn-sign-in {
  width: 100%;
  min-width: 200px;
  border-radius: 8px;
  height: 46px;
  box-shadow: none !important;
  border: 1px solid #C9C9C9 !important;
}
.btn-sign-in :deep(.v-btn__content),
.btn-sign-in span {
  text-transform: none !important;
}

.send-success-toast {
  position: fixed;
  top: 24px;
  left: 50%;
  transform: translateX(-50%);
  background: linear-gradient(100deg,#2ABF56,#135928);
  color: #fff;
  padding: 14px 32px;
  display: flex;
  align-items: center;
  font-size: 16px;
  font-weight: 600;
  border-radius: 14px;
  box-shadow: 0 4px 16px rgba(0,0,0,0.18);
  z-index: 2100;
  min-width: 320px;
  max-width: 480px;
  justify-content: center;
  border: 1px solid #fff;
  gap: 12px;
  animation: toast-fade-in 0.3s;
}
.toast-message {
  flex: 1;
  text-align: left;
  letter-spacing: 0.01em;
}
@keyframes toast-fade-in {
  from { opacity: 0; transform: translateX(-50%) translateY(-16px); }
  to { opacity: 1; transform: translateX(-50%) translateY(0); }
}

@-moz-document url-prefix() {
  .login-scroll-container {
    scrollbar-width: thin;
    scrollbar-color: rgba(0, 0, 0, 0.3) transparent;
  }
}

/* Custom scrollbar สำหรับ webkit browsers (Chrome, Safari) */
.login-scroll-container::-webkit-scrollbar {
  width: 6px;
}

.login-scroll-container::-webkit-scrollbar-track {
  background: transparent;
}

.login-scroll-container::-webkit-scrollbar-thumb {
  background-color: rgba(0, 0, 0, 0.3);
  border-radius: 6px;
}

::v-deep .v-input__control .v-input__slot .v-text-field__slot input {
  font-size: 16px !important;
}

.form-group {
  text-align: left;
}

.form-group label {
  display: block;
  font-size: 14px;
  color: #ffffff;
}

.form-group input {
  width: 100%;
  padding: 10px;
  border: 1px solid #C9C9C9;
  border-radius: 30px;
  font-size: 14px;
}

.form-group input:focus {
  border: #007bff;
}

.forgotPassword {
  color: #001763;
  font-weight: 600;
  text-decoration: underline;
}

.login-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
}

.user-image {
  width: 150px;
  height: 150px;
  border-radius: 50%;
  overflow: hidden;
  box-shadow: 8px 10px 12px rgba(0, 0, 0, 0.18);
}

.user-image img {
  width: 100%;
  height: auto;
}

.changeAccount {
  position: absolute;
  bottom: 10px;
  font-size: 18px;
  margin-top: 10px;
  text-decoration: none;
  color: #007bff;
}

.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter,
.fade-leave-to {
  opacity: 0;
}
.bg-image-container {
  position: relative;
  height: 100vh;
  overflow: hidden;
}

.full-height-image {
  position: absolute;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.forgot-container {
  margin-top: 20px;
  align-items: center;
}

.img-chat {
  display: flex;
  justify-content: center;
  align-items: center;
}

.forgot-buttons {
  width: 100%;
  display: flex;
  justify-content: space-between;
  padding: 0px 10px;
  gap: 12px;
  margin-top: 16px;
}

@media (max-width: 600px) {
  #sign-in {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 28px;
  margin-top: 1rem;
}
  .forgot-buttons {
    flex-direction: row;
    width: 100%;
    padding: 0;
    gap: 10px;
    margin-top: 16px;
  }
  .forgot-login,
  .forgot-send {
    width: 95% !important;
    margin-left: 10px !important;
    display: flex;
    flex-direction: row;
  }
  .forgot-input {
    width: 100% !important;
  }
}

@media (max-width: 1024px) {
  #sign-in {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 28px;
  margin-top: 1rem;
}
  .forgot-buttons {
    flex-direction: column;
    width: 100%;
    padding: 0;
    gap: 10px;
    margin-top: 16px;
  }
  .forgot-login,
  .forgot-send {
    width: 100% !important;
    margin-left: 0px !important;
    display: flex;
    flex-direction: row;
  }
  .forgot-input {
    width: 100% !important;
  }
}

.forgot-input {
  width: 100%;
  border-radius: 12px;
  font-size: 14px;
}

@media screen and (max-width:900px) {
  /* .bg-image-container {
    display: none;
  } */
}
.animated-input {
  background: #ffffff;
  border: 1px solid #c9c9c9;
}

.username-filled ::v-deep .v-field__input {
  transform: translateY(2px);
  padding: 4px;
  left: 12px;
  cursor: pointer !important;
}

.field-icon {
  display: flex;
  align-items: center;
  margin-bottom: 7px;
  margin-right: 12px;
  margin-top: -6px;
}

/* Placeholder text */
.floating-placeholder {
  position: absolute;
  top: 50%;
  left: 16px;
  transform: translateY(-50%);
  color: #aaa;
  font-size: 14px;
  transition: all 0.3s ease;
  pointer-events: none;
}

/* Move to right when user types */
.move-right {
  left: auto;
  right: 50px; /* adjust for your icon spacing */
  color: #cccccc;
}

/* Hide Vuetify's native placeholder */
.v-field__input::placeholder {
  opacity: 0;
}
.logo-container {
  position: relative;
  display: inline-block;
}
.label-version {
  display: flex;
  padding: 6px 12px 4px 12px;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  color: var(--main, #C32E0E);
  font-size: 12px;
  font-style: normal;
  font-weight: 500;
  border-radius: 24px;
  background: linear-gradient(91deg, rgba(246, 119, 96, 0.10) 1.14%, rgba(195, 46, 14, 0.10) 46.51%, rgba(246, 119, 96, 0.10) 120.41%);
  position: absolute;
  bottom: 15px;        /* adjust to fine-tune placement */
  right: -120px;           /* align to bottom-right of logo */
  
}
</style>
